import { useEffect } from "react";

type UseBlockUnderlayScrollWhileOpenProperties = {
  isMobile: boolean;
  isOpen: boolean;
};

/**
 * Blocks the underlay scroll when the calendar is opened on mobile.
 * Keeps logic minimal and reusable across single/range pickers.
 */
export function useBlockUnderlayScrollWhileOpen({
  isMobile,
  isOpen,
}: UseBlockUnderlayScrollWhileOpenProperties) {
  useEffect(() => {
    if (isMobile && isOpen) {
      const originalOverflow = document.body.style.overflow;
      const originalTouchAction = document.body.style.touchAction;

      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
      return () => {
        if (originalOverflow === "") {
          document.body.style.removeProperty("overflow");
        } else {
          document.body.style.overflow = originalOverflow;
        }

        if (originalTouchAction === "") {
          document.body.style.removeProperty("touch-action");
        } else {
          document.body.style.touchAction = originalTouchAction;
        }
      };
    }
  }, [isMobile, isOpen]);
}
